export * from './MenuVersionMappingList';

export const getParentKey = (nodeKey, treeData) => {
  const findParent = (nodes, targetKey, parentKey = null) => {
    for (const node of nodes) {
      if (node.key === targetKey) {
        return parentKey;
      }
      if (node.children?.length > 0) {
        const found = findParent(node.children, targetKey, node.key);
        if (found) return found;
      }
    }
    return null;
  };

  return findParent(treeData, nodeKey);
};
